import { APIcallerv2 } from '@services/APIcaller';

const getClientCustomInputs = () => APIcallerv2.apiGet('/client-custom-inputs');

const updateClientCustomInputs = (inputs) => APIcallerv2.apiPost('/client-custom-inputs', inputs);

export default {
  getClientCustomInputs,
  updateClientCustomInputs,
};
